export default __webpack_public_path__ + "static/media/filterDefault.90ecd465.svg";